import { useState, useEffect } from 'react';
import QuizStep from '../components/QuizStep';
import Form from '../components/Form';
import Result from '../components/Result';

const Quiz = props => {
    const [quiz, setQuiz] = useState();
    const [stepIndex, setStepIndex] = useState(0);
    const [isEnded, setIsEnded] = useState(false);
    const [user, setUser] = useState();
    const [answers, setAnswers] = useState([]);

    function getAnswer(questionOrder){
        const answer = answers.find(a=>a.order === questionOrder);
        return answer;
    }

    useEffect(() => {
        if (!quiz) {
            import('../api/quiz.json').then(res => {
                const quiz = res.default;

                const questionsToPass = [];
                quiz.steps.forEach(s => {
                    s.questions.forEach(q => {
                        if (q.addToStep) {
                            const stepIndex = quiz.steps.findIndex(s => s.title === q.addToStep)
                            questionsToPass.push({ ...q, order: `${q.order}from${s.title}`, originalOrder: q.order, pass: true, stepIndex })
                        }
                    });
                });
                questionsToPass.forEach(q => {
                    quiz.steps[q.stepIndex].questions.push(q);
                });

                setQuiz(quiz);

                // import('../api/test_answers.json').then(res => {
                //     const a = res.default;
                //     import('../api/test_user.json').then(res => {
                //         const u = res.default;
                //         setAnswers(a);
                //         setUser(u);
                //         setQuiz(quiz);
                //         setIsEnded(true);
                //     });
                // });                
            })
        }
    });

    function goNextStep(new_answers) {
        setAnswers([...answers.slice(0), ...new_answers]);
        const new_stepIndex = stepIndex + 1;
        if (new_stepIndex >= quiz.steps.length) {
            setIsEnded(true);
        } else {
            setStepIndex(new_stepIndex);
        }
    }

    function goNextUser(new_user) {
        setUser(new_user);
    }

    return isEnded ? <Result user={user} answers={answers} quiz={quiz} /> :
        !user ? <Form goNext={goNextUser} step={quiz && quiz.steps[0]} /> : (
            <div>
                {quiz && <QuizStep getAnswer={getAnswer} step={quiz.steps[stepIndex]} goNext={goNextStep} />}
            </div>
        )
}
export default Quiz;
